import { isExternal, isEmpty, observeElements } from '../util/helpers'
//import Weather from '../util/weather'

export default {
  init() {
    // JavaScript to be fired on all pages
    const body = document.querySelector('body')
    const navToggle = document.querySelector('.js-toggle-nav')
    const anchors = [].slice.call(document.querySelectorAll('a'))
    const pTags = [].slice.call(document.querySelectorAll('p'))
    const heroBackground = document.querySelector('.js-hero')
    const backgrounds = [].slice.call(document.querySelectorAll('.js-background'))
    const listingMaps = [].slice.call(document.querySelectorAll('.js-map'))

    // Microsoft Edge
    if (window.StyleMedia) {
      document.body.classList.add('is-edge')
    }

    // Handle toggling mobile menu
    if (window.matchMedia('(max-width: 1023px)').matches) {
      if (navToggle) {
        navToggle.addEventListener('click', () => {
          body.classList.toggle('nav-is-open')
        })
      }
    }

    // Handle external urls
    anchors.forEach(anchor => {
      if (isExternal(anchor)) {
        // Define attributes to set
        const attributes = {
          target: '__blank',
          rel: 'noopener',
        }

        // Set attributes
        Object.keys(attributes).forEach(attribute => {
          anchor.setAttribute(attribute, attributes[attribute])
        })
      }
    })

    // Handle empty p tags
    pTags.forEach(isEmpty)

    // Handle hero background
    if (heroBackground) {
      const mobileHero = heroBackground.dataset.mobile
      const desktopHero = heroBackground.dataset.desktop

      if (!mobileHero && !desktopHero) return

      heroBackground.classList.add('has-background')

      if (window.matchMedia('(min-width: 1024px)').matches) {
        heroBackground.style.backgroundImage = `url(${desktopHero})`
      } else {
        heroBackground.style.backgroundImage = `url(${mobileHero})`
      }
    }

    // Handle container backgrounds
    if (backgrounds) {
      if (('IntersectionObserver' in window)) {
        let observer = new IntersectionObserver(observeElements);

        backgrounds.forEach(background => {
          observer.observe(background)
        })
      } else {
        backgrounds.forEach(background => {
          const mobileBG = background.dataset.mobile
          const desktopBG = background.dataset.desktop

          if (!mobileBG && !desktopBG) return

          if (window.matchMedia('(min-width: 1024px)').matches) {
            background.style.backgroundImage = `url(${desktopBG})`
          } else {
            background.style.backgroundImage = `url(${mobileBG})`
          }

          background.classList.add('has-loaded')
        })
      }
    }

    // Handle map backgrounds
    listingMaps.forEach(listingMap => {
      if (!listingMap.dataset.map) return

      if (window.matchMedia('(min-width: 1024px)').matches) {
        listingMap.addEventListener('mouseenter', function () {
          this.style.backgroundImage = `url(${this.dataset.map})`
        })

        listingMap.addEventListener('mouseleave', function () {
          this.style.backgroundImage = `url(${this.dataset.desktop})`
        })
      }
    })

    if ($('[data-fancybox]').length) {
      $('[data-fancybox]').fancybox()
    }

    if ($('.js-testimonials').length) {
      $('.js-testimonials').slick({
        accessibility: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      })
    }

    if ($('.js-resort--slider').length) {
      $('.js-resort--slider').slick({
        accessibility: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 150000,
        fade: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding:'100px',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              arrows: false,
            },
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              arrows: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: false,
              centerPadding:'30px',
            },
          },
        ],
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js